import {ChangeDetectorRef, Component, Input} from "@angular/core";
import {AbstractField} from "../field/abstract-field";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    selector: "woa-decimal-field",
    templateUrl: "./decimal-field.component.html",
    providers: [{provide: NG_VALUE_ACCESSOR, useExisting: DecimalFieldComponent, multi: true}]
})
export class DecimalFieldComponent extends AbstractField {
    @Input() autocomplete: "username" | "one-time-code" | "cc-csc";
    @Input() maxlength: string;

    DecimalFieldComponent = DecimalFieldComponent;

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    public static validateCharacter(event: KeyboardEvent): void {
        if (["Backspace", "ArrowLeft", "ArrowRight", "Tab", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].indexOf(event.key) == -1) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    public static correctInput(event: KeyboardEvent): void {
        event.target["value"] = event.target["value"].replace(/\D/g, "");
    }
}



// WEBPACK FOOTER //
// ./src/app/inputs/decimal-field/decimal-field.component.ts